import React from 'react';

function Impressum() {
  return (
    <main id="main-content" role="main">
      {/* Hero Section */}
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">Impressum</h1>
              <p className="hero__subtitle">
                Rechtliche Angaben gemäß § 5 TMG und § 55 RStV
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impressum Content */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-wrapper">
            <div className="legal-section">
              <h2>Angaben gemäß § 5 DDG:</h2>

              <div className="company-info">
                <h3>track by track GmbH</h3>
                <address>
                  Schliemannstr. 23<br />
                  10437 Berlin<br />
                  Deutschland
                </address>
              </div>

              <div className="legal-section">
                <h3>Vertreten durch:</h3>
                <p>Tobias Sander</p>
              </div>

              <div className="legal-section">
                <h3>Kontakt:</h3>
                <p>
                  <strong>Telefon:</strong> <a href="tel:+4930403665430">030 403 665 430</a><br />
                  <strong>Telefax:</strong> 030 403 665 450<br />
                  <strong>E-Mail:</strong> <a href="mailto:info@famefact.com">info@famefact.com</a>
                </p>
              </div>

              <div className="legal-section">
                <h3>DUNS-Nummer:</h3>
                <p>34-024-8055</p>
              </div>

              <div className="legal-section">
                <h3>Registereintrag:</h3>
                <p>
                  Eintragung im Handelsregister<br />
                  <strong>Registergericht:</strong> Amtsgericht Berlin-Charlottenburg<br />
                  <strong>Registernummer:</strong> HRB 129805 B
                </p>
              </div>

              <div className="legal-section">
                <h3>Umsatzsteuer:</h3>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                  <strong>DE814954842</strong>
                </p>
              </div>

              <div className="legal-section">
                <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h3>
                <p>
                  Tobias Sander<br />
                  Schliemannstr. 23<br />
                  10437 Berlin
                </p>
              </div>

              <div className="legal-section">
                <h3>Streitschlichtung</h3>
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener"> https://ec.europa.eu/consumers/odr</a>
                </p>
                <p>
                  Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet,
                  an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>

              <div className="legal-section">
                <h3>Haftung für Inhalte</h3>
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                  Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                  Tätigkeit hinweisen.
                </p>
              </div>

              <div className="legal-section">
                <h3>Haftung für Links</h3>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                  Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                  Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
                  der Seiten verantwortlich.
                </p>
              </div>

              <div className="legal-section">
                <h3>Urheberrecht</h3>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
                  dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
                  der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
                  Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>

              <div className="legal-section">
                <h3>Datenschutz</h3>
                <p>
                  Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich.
                  Weitere Informationen zum Datenschutz finden Sie in unserer
                  <a href="/datenschutz"> Datenschutzerklärung</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Impressum;
